(ns portal.advertiser-configuration-page.view.general
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Typography$default" :as Typography]
            [common.modal.view :refer [confirmation-modal defmodal]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.advertiser :as q :refer [upgrade-demo-account-mutation]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.panel :refer [panel]]
            [portal.advertiser-configuration-page.db.core :as form]
            [portal.advertiser-configuration-page.view.whitelist :refer [whitelist-form]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui error-alert []
  (when-let [error (use-subscribe [:form.advertiser-configuration/backend-error])]
    ($ Alert {:severity "error"
              :sx #js {:mt 2}}
       (str "An error occurred (" error ")"))))

(defui name-panel []
  ($ panel {:title "Advertiser"
            :actions ($ Button
                        {:type "submit"
                         :variant "contained"
                         :data-testid :advertiser-config-button--general-save}
                        "Save")
            :data-testid :advertiser-config-panel--name}
     ($ Stack
        {:spacing 2}
        ($ form-field
           {:label "Name"
            :err-msg (form/use-error-message [:name])
            :sx #js {:width "30rem"}
            :data-testid :advertiser-config-form--advertiser-name}
           ($ input
              (form/use-bind-control [:name])))
        ($ form-field
           {:label "Shortcode"
            :err-msg (form/use-error-message [:code])
            :sx #js {:width "30rem"}
            :data-testid :advertiser-config-form--advertiser-shortcode}
           ($ input
              (form/use-bind-control [:code]))))))

(defui backup-url-panel []
  ($ panel {:title "Backup URL"
            :data-testid :advertiser-config-panel--backup-url}
     ($ form-field
        {:label "Backup URL"
         :err-msg (form/use-error-message [:backupLandingPageUrl])
         :sx #js {:width "30rem"}
         :data-testid :advertiser-config-form--backup-url}
        ($ input
           (merge (form/use-bind-control [:backupLandingPageUrl])
                  {:placeholder "Type a backup URL"})))))

(defmodal confirm-demo-status-removal :advertiser-configuration/confirm-demo-status-removal
  [{:keys [remove-demo-status-fn]}]
  ($ confirmation-modal {:title "Upgrade Account"
                         :confirm-details "Upgrading Demo Account to regular Account. This action is permanent and cannot be undone."
                         :action-fn remove-demo-status-fn}))

(defui wpp-open-panel []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{:keys [osWorkspaceInfo isDemo]} :data} (use-query (q/advertiser-query {:advertiser-id advertiser-id}))
        {upgrade-demo-account :mutate} (use-mutation (upgrade-demo-account-mutation advertiser-id))
        {:keys [client market brand]} osWorkspaceInfo]
    ($ panel {:title "WPP Open Data"
              :data-testid :wpp-open-data-panel}
       ($ Stack
          {:spacing 2}
          (when (every? nil? [client market brand])
            ($ Typography {:variant "normal"} "Advertiser is not connected to any WPP Open Workspace."))
          (when client
            ($ Stack {:direction "row" :gap 1}
               ($ Typography {:variant "h4"} "Client:")
               ($ Typography {:variant "normal"} (:name client))))
          (when market
            ($ Stack {:direction "row" :gap 1}
               ($ Typography {:variant "h4"} "Market:")
               ($ Typography {:variant "normal"} (:name market))))
          (when brand
            ($ Stack {:direction "row" :gap 1}
               ($ Typography {:variant "h4"} "Brand:")
               ($ Typography {:variant "normal"} (:name brand))))
          ($ Stack {:direction "row" :gap 1}
             ($ Typography {:variant "h4"} "Account Status:")
             ($ Typography {:variant "normal"} (if isDemo "Demo Account" "Regular Account")))
          (when isDemo
            ($ Button {:variant "contained"
                       :color "error"
                       :onClick #(rf/dispatch
                                  [:modal/open {:id :advertiser-configuration/confirm-demo-status-removal
                                                :props {:remove-demo-status-fn
                                                        (fn [] (upgrade-demo-account advertiser-id))}}])
                       :sx #js {:width 160}}
               "Upgrade account"))))))

(defui interaction-tracking-panel []
  (let [{:keys [value]} (form/use-bind-control [:interactionTrackingEnabled])]
    ($ panel {:title "Interaction metrics"}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :gap 1}
          ($ Switch
             {:checked (boolean value)
              :on-change #(rf/dispatch [:form.advertiser-configuration/on-change [:interactionTrackingEnabled] (not value)])})
          ($ Typography {:component "span"}
             "Enable interactions metrics")))))

(defui base-form []
  ($ Stack
     {:component "form"
      :spacing 4
      :on-submit (fn [e]
                   (.preventDefault e)
                   (rf/dispatch [:form.advertiser-configuration/submit]))}
     ($ name-panel)
     ($ wpp-open-panel)
     ($ backup-url-panel)))

(defui general-tab []
  ($ :<>
     ($ error-alert)
     ($ base-form)
     ($ whitelist-form)
     ($ interaction-tracking-panel)))
